var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a-spin", { attrs: { size: "large", spinning: _vm.loading } }, [
    _c("div", [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "title", class: [_vm.lang] },
          [
            _c("a-icon", {
              staticClass: "icon",
              style: { "margin-left": _vm.lang == "AR" ? "5px" : 0 },
              attrs: { type: "control" },
            }),
            _vm._v(" " + _vm._s(_vm.$t("PersonalizedTrainingSession")) + " "),
          ],
          1
        ),
        _c("div", { staticClass: "subtitle", class: [_vm.lang] }, [
          _vm._v(" " + _vm._s(_vm.$t("LetSnowtrainAI")) + " "),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "list" },
        _vm._l(_vm.list, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "item-box" },
            [
              _c("div", { staticClass: "title", class: [_vm.lang] }, [
                _c(
                  "span",
                  {
                    staticClass: "index",
                    style: { "margin-left": _vm.lang == "AR" ? "5px" : 0 },
                  },
                  [_vm._v(_vm._s(item.index))]
                ),
                _vm._v(_vm._s(item.title) + " "),
              ]),
              _c("div", { staticClass: "des", class: [_vm.lang] }, [
                _vm._v(" " + _vm._s(item.subtitle) + " "),
              ]),
              !item.open
                ? _c("a-icon", {
                    staticClass: "openBtn",
                    style: {
                      left: _vm.lang == "AR" ? "20px" : "inherit",
                      right: _vm.lang != "AR" ? "30px" : "inherit",
                    },
                    attrs: { type: "down" },
                    on: {
                      click: function ($event) {
                        return _vm.openHandler(item)
                      },
                    },
                  })
                : _vm._e(),
              item.open
                ? _c("a-icon", {
                    staticClass: "openBtn",
                    style: {
                      left: _vm.lang == "AR" ? "20px" : "inherit",
                      right: _vm.lang != "AR" ? "30px" : "inherit",
                    },
                    attrs: { type: "up" },
                    on: {
                      click: function ($event) {
                        return _vm.openHandler(item)
                      },
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: item.open,
                      expression: "item.open",
                    },
                  ],
                },
                [
                  _c("div", { staticClass: "cont-box" }, [
                    _c(
                      "div",
                      { staticClass: "stitle" },
                      [
                        _vm._v(" " + _vm._s(_vm.$t("SampleMessage")) + " "),
                        item.can_translate
                          ? [
                              !item.gloading
                                ? _c(
                                    "a-tooltip",
                                    {
                                      attrs: { placement: "bottom" },
                                      model: {
                                        value: item.showModal,
                                        callback: function ($$v) {
                                          _vm.$set(item, "showModal", $$v)
                                        },
                                        expression: "item.showModal",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _c("p", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.lang == "CN"
                                                  ? item.translation_hint.cn
                                                  : _vm.lang == "US"
                                                  ? item.translation_hint.us
                                                  : item.translation_hint.ar
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                      _c(
                                        "span",
                                        [
                                          _c("a-icon", {
                                            staticStyle: {
                                              color: "red",
                                              "margin-left": "5px",
                                            },
                                            attrs: {
                                              type: "exclamation-circle",
                                              theme: "filled",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _c(
                                "a-button",
                                {
                                  staticStyle: {
                                    color: "#fff",
                                    background: "red",
                                    "border-color": "red",
                                    "margin-left": "5px",
                                  },
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.generateHandler(item)
                                    },
                                  },
                                },
                                [
                                  item.gloading
                                    ? _c("a-icon", {
                                        staticClass: "icon",
                                        attrs: { type: "sync", spin: "" },
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        !item.gloading
                                          ? _vm.$t("Regenerate")
                                          : _vm.$t("Regenerating")
                                      )
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("div", {
                      staticClass: "cont",
                      style: { color: item.color ? item.color : "#000" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.formatText(
                            item.new_simulate_content
                              ? item.new_simulate_content
                              : item.cont
                          )
                        ),
                      },
                    }),
                  ]),
                  _vm.lang !== "AR"
                    ? _c("div", { staticClass: "addTitle" }, [
                        _c("span", { staticClass: "tit", class: [_vm.lang] }, [
                          _vm._v(
                            "🎓 " + _vm._s(_vm.$t("TeachAIYourConversation"))
                          ),
                        ]),
                        !item.loading && !item.gloading
                          ? _c(
                              "span",
                              {
                                staticClass: "btn",
                                class: [_vm.lang],
                                on: {
                                  click: function ($event) {
                                    return _vm.addItem(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "+" + _vm._s(_vm.$t("AddTrainingPhrases"))
                                ),
                              ]
                            )
                          : _vm._e(),
                        item.loading || item.gloading
                          ? _c(
                              "span",
                              {
                                staticClass: "btn",
                                class: [_vm.lang],
                                staticStyle: {
                                  color: "#fff",
                                  "background-color": "#bbbbbb",
                                  cursor: "not-allowed",
                                },
                              },
                              [
                                _vm._v(
                                  "+" + _vm._s(_vm.$t("AddTrainingPhrases"))
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _c("div", { staticClass: "addTitle" }, [
                        _c(
                          "span",
                          {
                            staticClass: "btn",
                            class: [_vm.lang],
                            on: {
                              click: function ($event) {
                                return _vm.addItem(item)
                              },
                            },
                          },
                          [_vm._v("+" + _vm._s(_vm.$t("AddTrainingPhrases")))]
                        ),
                        _c("span", { staticClass: "tit", class: [_vm.lang] }, [
                          _vm._v(
                            "🎓 " + _vm._s(_vm.$t("TeachAIYourConversation"))
                          ),
                        ]),
                      ]),
                  _c(
                    "ul",
                    _vm._l(item.scriptList, function (jitem, jindex) {
                      return _c("li", { key: jindex }, [
                        _vm.lang != "AR"
                          ? _c(
                              "div",
                              { staticClass: "sciptIndex" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "index", class: [_vm.lang] },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .$t("Script")
                                          .replace("1", jindex + 1)
                                      )
                                    ),
                                  ]
                                ),
                                jindex != 0 && !item.loading
                                  ? _c("a-icon", {
                                      staticClass: "del",
                                      attrs: { type: "delete" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.delHandler(jindex, item)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.lang == "AR"
                          ? _c(
                              "div",
                              { staticClass: "sciptIndex", class: [_vm.lang] },
                              [
                                jindex != 0 && !item.loading
                                  ? _c("a-icon", {
                                      staticClass: "del",
                                      attrs: { type: "delete" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.delHandler(jindex, item)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _c(
                                  "span",
                                  { staticClass: "index", class: [_vm.lang] },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .$t("Script")
                                          .replace("1", jindex + 1)
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "scriptInput" },
                          [
                            _c("a-input", {
                              class: [_vm.lang],
                              attrs: {
                                disabled:
                                  item.loading || item.gloading ? true : false,
                                type: "textarea",
                                "auto-size": { minRows: 5, maxRows: 10 },
                                placeholder:
                                  _vm.campaign_type == 1
                                    ? _vm.$t("salesExpt" + item.index)
                                    : _vm.$t("hrExpt" + item.index),
                              },
                              on: {
                                click: function ($event) {
                                  _vm.clickInput(
                                    jitem,
                                    _vm.campaign_type == 1
                                      ? _vm.$t("salesExpt" + item.index)
                                      : _vm.$t("hrExpt" + item.index)
                                  )
                                },
                              },
                              model: {
                                value: jitem.value,
                                callback: function ($$v) {
                                  _vm.$set(jitem, "value", $$v)
                                },
                                expression: "jitem.value",
                              },
                            }),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  ),
                  _c("div", { staticStyle: { visibility: "hidden" } }, [
                    _vm._v(_vm._s(item.timeteamp)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "wrap-btn" },
                    [
                      !item.loading && !item.gloading
                        ? _c(
                            "a-button",
                            {
                              staticClass: "btn",
                              class: [_vm.lang],
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.useDefaultHandler(item)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("UseDefaultScript")))]
                          )
                        : _vm._e(),
                      item.loading || item.gloading
                        ? _c(
                            "a-button",
                            {
                              staticClass: "btn disabledClass",
                              class: [_vm.lang],
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.useDefaultHandler(item)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("UseDefaultScript")))]
                          )
                        : _vm._e(),
                      _c(
                        "a-button",
                        {
                          staticClass: "btn",
                          class: [_vm.lang],
                          staticStyle: {
                            "background-color": "rgba(184, 134, 248, 1)",
                            color: "#fff",
                          },
                          attrs: {
                            disabled:
                              item.loading || item.gloading ? true : false,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.saveStepHandler(item)
                            },
                          },
                        },
                        [
                          item.loading
                            ? _c("a-icon", {
                                staticClass: "icon",
                                attrs: { type: "sync", spin: "" },
                              })
                            : _vm._e(),
                          _vm._v(
                            " " +
                              _vm._s(
                                item.loading
                                  ? _vm.$t("AIischecking")
                                  : _vm.$t("saveandAIcheck")
                              )
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  item.loading
                    ? _c(
                        "div",
                        { staticClass: "tipsloading" },
                        [
                          _c("a-icon", {
                            staticClass: "icon",
                            attrs: { type: "sync", spin: "" },
                          }),
                          _vm._v(
                            " " + _vm._s(_vm.$t("checkingthewording")) + " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  item.status == 2 &&
                  item.corpus_examples &&
                  item.corpus_examples.length > 0 &&
                  !item.loading
                    ? _c("div", { staticClass: "passed" }, [
                        _c("span", [_vm._v(_vm._s(_vm.$t("passed")))]),
                        _vm._v(" " + _vm._s(_vm.$t("Contentapproved")) + " "),
                      ])
                    : _vm._e(),
                  item.status == 4 && !item.loading
                    ? _c("div", { staticClass: "passed failed" }, [
                        _c("span", [_vm._v(_vm._s(_vm.$t("Failed")))]),
                        _vm._v(" " + _vm._s(_vm.$t("Contentrejected")) + " "),
                      ])
                    : _vm._e(),
                  item.status == 4 && !item.loading
                    ? _c(
                        "div",
                        {
                          staticClass: "cont-box",
                          staticStyle: {
                            "margin-top": "18px",
                            "background-color": "#ffefbd",
                            "border-left-color": "#ffc109",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "stitle",
                              staticStyle: {
                                color: "#000",
                                "font-size": "16px",
                                "font-weight": "bold",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("Suggestededits")) + " "
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "cont" }, [
                            _vm._v(" " + _vm._s(item.suggestion) + " "),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          )
        }),
        0
      ),
      _c("div", { staticClass: "wrap-easy" }, [
        _c(
          "ul",
          _vm._l(_vm.list2, function (item, index) {
            return _c("li", { key: index }, [
              _c("div", { staticClass: "title" }, [
                _c("span", { staticClass: "index" }, [
                  _vm._v(_vm._s(item.index)),
                ]),
                _vm._v(_vm._s(item.title) + " "),
              ]),
              _c("div", { staticClass: "des" }, [
                _vm._v(_vm._s(item.subtitle)),
              ]),
              _c(
                "div",
                { staticClass: "fullscreen" },
                [
                  _c("a-icon", {
                    staticClass: "icon",
                    attrs: { type: "fullscreen" },
                    on: {
                      click: function ($event) {
                        return _vm.handleFullScreen(item, index)
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          }),
          0
        ),
      ]),
      _vm.list2.length > 0
        ? _c("div", { staticClass: "tips" }, [
            _vm._v(" " + _vm._s(_vm.$t("TohavetheAImaster")) + " "),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "main-btn" },
        [
          _c(
            "a-button",
            {
              staticClass: "btn",
              class: [_vm.lang],
              on: { click: _vm.backHandler },
            },
            [_vm._v(_vm._s(_vm.$t("Back")))]
          ),
          _c(
            "a-button",
            {
              staticClass: "btn",
              class: [_vm.lang],
              attrs: { type: "primary" },
              on: { click: _vm.saveAll },
            },
            [_vm._v(_vm._s(_vm.$t("Nextstep")))]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }